import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=4f97fa90&scoped=true&"
import script from "./my-table.vue?vue&type=script&lang=js&"
export * from "./my-table.vue?vue&type=script&lang=js&"
import style0 from "./my-table.vue?vue&type=style&index=0&id=4f97fa90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97fa90",
  null
  
)

export default component.exports